import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z
  .object({
    tripId: z.string().optional(),
    status: z.string().optional(),
    anonymous: z.union([z.string(), z.boolean()]).optional(),
    action: z.string().optional(),
    checkout: z.string().optional(),
    returnView: z.string().optional(),
  })
  .passthrough();

export const Route = createFileRoute('/$locale/itinerary')({
  validateSearch: searchSchema,
});
